import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { customTokens } from 'src/utils/theme';

export const useHealthTrackerCardStyles = makeStyles({
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', customTokens.colorNeutralBackground8),
    borderRadius: tokens.borderRadiusMedium,
    ...shorthands.padding(tokens.spacingHorizontalL),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxShadow: tokens.shadow2,
    minHeight: '142px',
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  consumerName: {
    marginTop: tokens.spacingVerticalXS,
    marginBottom: tokens.spacingHorizontalS,
    color: tokens.colorNeutralForeground3,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase400,
    fontSize: tokens.fontSizeBase400,
  },
  value: {
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase500,
  },
  unit: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
  },
  date: {
    marginTop: 0,
    marginBottom: tokens.spacingHorizontalS,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    lineHeight: '100%',
    fontWeight: tokens.fontWeightRegular,
  },
  valueRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: tokens.spacingHorizontalS,
  },
  iconContainer: {
    'marginBottom': tokens.spacingHorizontalS,
    '& svg': {
      width: tokens.fontSizeHero700,
      height: tokens.fontSizeHero700,
    },
  },
});
